import request from '../utils/request'

export async function login (params) {
  return request('login', {
    data: params
  })
}

export async function logout (sessionToken) {
  return request('logout', {
    sessionToken: sessionToken
  })
}

export async function userInfo (objectId, params) {
  return request(`_User/${objectId}`, {
    method: 'GET',
    data: params
  })
}


// WEBPACK FOOTER //
// ./src/services/login.js